import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string | { message?: string } | undefined;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    const errorMessage = typeof error === 'string'
      ? error
      : error && typeof error === 'object' && 'message' in error
        ? String(error.message || '')
        : undefined;

    return (
      <div className="space-y-1">
        <textarea
          className={cn(
            "flex min-h-[96px] w-full rounded-xl border border-slate-200/90 bg-white/90 px-3.5 py-2.5 text-sm text-foreground ring-offset-background shadow-[0_1px_2px_rgba(15,23,42,0.04)] placeholder:text-muted-foreground/90 transition-all duration-200 focus-visible:border-blue-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400/60 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:bg-slate-900/72",
            errorMessage && "border-red-500",
            className
          )}
          ref={ref}
          {...props}
        />
        {errorMessage && (
          <p className="text-sm text-red-500">{errorMessage}</p>
        )}
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }